// Per-practice beta-feature gating, admin-managed via PUT /api/v2/practices/feature-flags/:practiceId
// (backed by PracticeBetaFeature); dashboard reads it via GET /user/beta-features (services/user.ts).
interface UserWithBetaFeatures {
    betaFeatures?: string[];
}

export function hasBetaFeature(
    user: UserWithBetaFeatures | null | undefined,
    feature: string
): boolean {
    return user?.betaFeatures?.includes(feature) ?? false;
}
